











import { Component, Vue, Prop } from "vue-property-decorator";
import { className } from "@/utilities";

@Component({ components: {} })
export default class ZoneNavButton extends Vue {
  @Prop() readonly name!: string;
  @Prop() readonly alias!: string;

  get zoneClassName() {
    return className(this.alias);
  }
}
